module.exports = __webpack_public_path__ + "static/album-tristan-generation.dc05fd3f.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/album-tristan-generation.jpg
// module id = 1321
// module chunks = 4